let isMobileToggleBound = false;

function schoolsToggle() {
    const isMobile = $(window).width() < 1024;

    if (isMobile && !isMobileToggleBound) {
        $('.schools > .wp-block-heading').each(function (){
            const content = $(this).text();
            $(this).text('').append(`<button type="button" aria-expanded="false">${content}</button>`)
            $(this).siblings().attr('aria-hidden', 'true');
        });
        $('body').on('click.mobileToggle', '.schools > .wp-block-heading button', function (e) {
            e.preventDefault();
            $(this).parent().toggleClass('open');
            $(this).attr('aria-expanded', $(this).parent().hasClass('open') ? 'true' : 'false');
            $(this).parent().siblings().attr('aria-hidden', $(this).parent().hasClass('open') ? 'false' : 'true');
            $(this).parent().siblings().slideToggle(150);
        });
        isMobileToggleBound = true;
    } else if (!isMobile && isMobileToggleBound) {
        $('.schools > .wp-block-heading').each(function (){
            const content = $(this).text();
            $(this).text('').append(`${content}`)
            $(this).siblings().removeAttr('aria-hidden');
        });
        $('body').off('click.mobileToggle');
        isMobileToggleBound = false;
    }
}

$(document).ready(function () {
    schoolsToggle();
    $(window).on('resize', schoolsToggle);
});